import React, { useEffect, useState, useContext, useRef, useCallback } from 'react';
import Sidedash from '../uicomponents/Sidedash';
import { Link } from 'react-router-dom';
import { formatDate } from '../utils/Utilsfunc';
import AlertContext from '../../context/AlertContext';
import ClearDuesModal from '../modals/ClearDuesModal';
import DeleteConfirmationModal from '../modals/DeleteConfirmationModal';



const BookingManager = () => {
    const [bookings, setBookings] = useState([]);
    const host = process.env.REACT_APP_BACKEND_URL;
    const { showAlert } = useContext(AlertContext)
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalBookings, setTotalBookings] = useState(0); // If your API returns total count
    const limit = 15;
    const [showModal, setShowModal] = useState(false);
    const [selectedBooking, setSelectedBooking] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [bookingToDelete, setBookingToDelete] = useState(null);
    const tableRef = useRef(null);
    const adminLoggedIn = localStorage.getItem('role')



    // Table scroll horizontally
    const scrollTable = (direction) => {
        if (tableRef.current) {
            const scrollAmount = direction === 'left' ? -400 : 400;
            tableRef.current.scrollTo({
                left: tableRef.current.scrollLeft + scrollAmount,
                behavior: 'smooth',
            });
        }
    };

    const handleOpenModal = (booking) => {
        setSelectedBooking(booking);
        setShowModal(true);
    }
    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedBooking(null);
    }

    const fetchBookings = useCallback(async (page = 1, query = '') => {
        try {
            // Make sure your backend supports these query parameters: page, limit, search
            const response = await fetch(`${host}/bookings/api/bookings?page=${page}&limit=${limit}&search=${query}`, {
                headers: {
                    "auth-token": localStorage.getItem('token'),
                },
            });
            const data = await response.json();
            // Assuming the response contains { bookings: [...], totalCount: number }
            setBookings(data.bookings ? data.bookings : []);
            if (data.totalCount) {
                setTotalBookings(data.totalCount);
            }
        } catch (error) {
            console.error('Error fetching bookings:', error);
        }
    }, [host, limit]);

    useEffect(() => {
        fetchBookings(currentPage, searchQuery);
    }, [currentPage, searchQuery, fetchBookings]);

    // Pagination
    const totalPages = Math.ceil(totalBookings / limit);


    //=================================
    // Handle clear dues
    const handleClearDues = async (bookingId, pCashValue, pOnlineValue) => {
        try {
            const response = await fetch(`${host}/bookings/api/clear-dues/${bookingId}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    "auth-token": localStorage.getItem('token'),
                },
                body: JSON.stringify({
                    updatePCash: pCashValue > 0,
                    updatePOnline: pOnlineValue > 0,
                    pCashValue,
                    pOnlineValue,
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Failed to clear dues:', errorData.message);
                return;
            }

            const data = await response.json();
            console.log('Dues cleared successfully:', data);
            // Update your state or UI as needed
            await fetchBookings();
        } catch (error) {
            console.error('Error clearing dues:', error);
        }
    };

    //=================================
    // Delete bookings
    const deleteBooking = async (bookingId) => {
        if (!bookingId) return;

        try {
            const response = await fetch(`${host}/bookings/api/delete/booking/${bookingId}`, {
                headers: {
                    "auth-token": localStorage.getItem('token'),
                },
                method: 'DELETE',
            });

            if (!response.ok) {
                const errorData = await response.json(); // If the server responds with an error, log it
                console.error('Failed to delete booking:', errorData.message);
                showAlert('Error deleting booking: ' + errorData.message, 'danger');
                return;
            }

            setBookings(bookings.filter((booking) => booking._id !== bookingId));
            showAlert('Booking Deleted', 'success');
            setShowDeleteModal(false); // Close the modal after deleting
        } catch (error) {
            console.error('Error deleting booking:', error);
            showAlert('Error deleting booking: ' + error.message, 'danger');
        }
    };

    //=================================
    // Send Receipts
    const sendReceipt = async (TxnId) => {
        //console.log('Sending receipt for:', TxnId);
        const spinnerId = `loading-${TxnId}`;
        const spinnerElement = document.getElementById(spinnerId);

        try {
            if (spinnerElement) {
                spinnerElement.style.display = 'block'; // Hide spinner after state change
            } else {
                console.warn(`Spinner element with ID 'loading-${TxnId}' not found.`); // Handle missing element
            }
            const response = await fetch(`${host}/bookings/send-receipt/${TxnId}`, {
                method: 'POST',
                // Optionally add headers and body for the request
            });

            if (!response.ok) {

                const errorResponse = await response.json(); // Parse the error response
                throw new Error(errorResponse.message || `Error sending receipt: ${response.statusText}`);
            }
            showAlert('Email Sent!', 'success')
            // Handle successful response
            console.log('Receipt sent successfully!');
        } catch (error) {
            console.error('Error sending receipt:', error);
            showAlert(error.message, 'danger')
        } finally {
            if (spinnerElement) {
                spinnerElement.style.display = 'none'; // Hide spinner after state change
            } else {
                console.warn(`Spinner element with ID 'loading-${TxnId}' not found.`); // Handle missing element
            }
        }
    };

    const handleSendReceipt = (txnId) => {
        sendReceipt(txnId);
    };

    //=================================
    // Sync Payment Status
    const syncPaymentStatus = async (bookingId) => {
        const spinnerId = `sync-loading-${bookingId}`;
        const spinnerElement = document.getElementById(spinnerId);

        try {
            if (spinnerElement) {
                spinnerElement.style.display = 'block';
            } else {
                console.warn(`Spinner element with ID 'sync-loading-${bookingId}' not found.`);
            }

            const response = await fetch(`${host}/payments/sync-payment/${bookingId}`, {
                method: 'POST',
                headers: {
                    "auth-token": localStorage.getItem('token'),
                },
            });

            if (!response.ok) {
                const errorResponse = await response.json();
                throw new Error(errorResponse.error || `Error syncing payment: ${response.statusText}`);
            }

            const data = await response.json();
            
            if (data.success) {
                const statusMessage = data.razorpayPaymentStatus ? 
                    `Payment status synchronized! Razorpay status: ${data.razorpayPaymentStatus}` : 
                    'Payment status synchronized successfully!';
                showAlert(statusMessage, 'success');
                // Refresh the bookings list to show updated status
                await fetchBookings(currentPage, searchQuery);
            } else {
                showAlert(data.message, 'warning');
            }

        } catch (error) {
            console.error('Error syncing payment:', error);
            showAlert(error.message, 'danger');
        } finally {
            if (spinnerElement) {
                spinnerElement.style.display = 'none';
            } else {
                console.warn(`Spinner element with ID 'sync-loading-${bookingId}' not found.`);
            }
        }
    };

    const handleSyncPayment = (bookingId) => {
        syncPaymentStatus(bookingId);
    };

    const handleDeleteClick = (booking) => {
        setBookingToDelete(booking);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setBookingToDelete(null);
    };

    useEffect(() => {
        console.log(bookingToDelete);
    }, [bookingToDelete]);


    return (
        <div>
            <div className="container-fluid">
                <div className="row">
                    <Sidedash />
                    <div className="col-md-10 pt-3">
                        <div className="row">
                            <div className="col-md-12">
                                <div className='container'>

                                    <div className='scrollbtn position-relative'>
                                        <button
                                            className='btn btn-primary shadow-sm'
                                            onClick={() => scrollTable('left')}
                                            style={{
                                                position: 'fixed',
                                                top: '120px',
                                                right: "60px",
                                                transform: 'translateY(-50%)',
                                                zIndex: 1000,
                                                borderRadius: '50%',
                                                width: '40px',
                                                height: '40px',
                                                padding: '0',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                                <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                                            </svg>
                                        </button>
                                        <button
                                            className='btn btn-primary shadow-sm'
                                            onClick={() => scrollTable('right')}
                                            style={{
                                                position: 'fixed',
                                                top: '120px',
                                                right: "10px",
                                                transform: 'translateY(-50%)',
                                                zIndex: 1000,
                                                borderRadius: '50%',
                                                width: '40px',
                                                height: '40px',
                                                padding: '0',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                                <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                            </svg>
                                        </button>
                                    </div>

                                    <div className="card rounded-4 border-0 shadow-sm">

                                        {/* Header Section */}
                                        <div className='card-header bg-gradient text-white border-0 py-4'>
                                            <div className='row align-items-center'>
                                                <div className='col-md-6'>
                                                    <h4 className='mb-0 fw-semibold text-white'>Bookings Management</h4>
                                                    <small className='text-white-50'>Manage and track all bookings</small>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='d-flex align-items-center justify-content-md-end mt-3 mt-md-0'>
                                                        <div className='input-group' style={{maxWidth: '400px'}}>
                                                            <span className='input-group-text bg-white border-end-0 mb-3'>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                                                                </svg>
                                                            </span>
                                                            <input
                                                                type="text"
                                                                className="form-control border-start-0 ps-0"
                                                                placeholder="Search by name, UHID, mobile..."
                                                                value={searchQuery}
                                                                onChange={(e) => {
                                                                    setCurrentPage(1);
                                                                    setSearchQuery(e.target.value);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body p-0">
                                            <div className="table-responsive" ref={tableRef} style={{maxHeight: 'calc(100vh - 300px)'}}>
                                                <table className="table table-hover bookings-table-modern mb-0">
                                                    <thead className='align-top bookings-table-head sticky-top'>
                                                        <tr className='text-secondary'>
                                                            <th>Payment Status</th>
                                                            <th>Booking Date</th>
                                                            <th>Client Txn ID</th>
                                                            <th>UHID</th>
                                                            <th>Customer Name</th>
                                                            <th>Payment Mode</th>
                                                            <th>Partial Payment</th>
                                                            <th>Amount Due</th>
                                                            <th className='fw-bold'>Total Amount</th>
                                                            <th>Seat Details</th>
                                                            <th>Locker</th>
                                                            <th>Locker Security</th>
                                                            <th>Receipt</th>
                                                            {/* <th>Created At</th> */}
                                                            <th>Sub Total</th>
                                                            <th>Discount Coupon</th>
                                                            <th>Discount Value</th>
                                                            {/* <th>Order Status</th> */}
                                                            <th>Payment Cash</th>
                                                            <th>Payment Online</th>
                                                            {/* <th>Payment Info</th> */}
                                                            <th>Extended to</th>
                                                            <th>Extension Details</th>
                                                            <th>Customer Email</th>
                                                            <th>Customer Mobile</th>
                                                            <th>Notes</th>
                                                            <th>Updated At</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className='bookings-table'>
                                                        {bookings.map((booking, index) => (
                                                            <tr key={index}>
                                                                <>
                                                                    <td className={`border-dark-subtle border-start border-end text-capitalize ${
                                                                        (booking.paymentStatus === 'paid') || (booking.paymentStatus === 'success') ? 'bg-success-subtle' : 
                                                                        booking.paymentStatus === 'failed' ? 'bg-danger-subtle' :
                                                                        booking.paymentStatus === 'refunded' ? 'bg-info-subtle' :
                                                                        'bg-warning-subtle'
                                                                    }`}>
                                                                        <span>{booking.paymentStatus}</span>
                                                                        {booking.udf2 && booking.udf2 !== '0' && (
                                                                            <>
                                                                                <span><button onClick={() => handleOpenModal(booking)} className='badge p-2 text-capitalize mt-1 mb-0'>Clear Dues</button></span>
                                                                                {selectedBooking && (
                                                                                    <ClearDuesModal
                                                                                        bookingId={selectedBooking._id}
                                                                                        amountDue={selectedBooking.udf2}
                                                                                        show={showModal}
                                                                                        handleClose={handleCloseModal}
                                                                                        handleClearDues={handleClearDues}
                                                                                        udf2Value={selectedBooking.udf2} // Pass the udf2 value from the booking data
                                                                                        cashOld={selectedBooking.pCash}
                                                                                        onlineOld={selectedBooking.pOnline}
                                                                                    />
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </td>
                                                                    <td>{formatDate(booking.bookingDate)}</td>
                                                                    <td>{booking.clientTxnId}</td>
                                                                    <td>{booking.bookedBy}</td>
                                                                    <td>{booking.customerName}</td>
                                                                    <td>
                                                                        {
                                                                            (booking.paymentStatus === 'success' || booking.upiTxnId || (booking.paymentUrl && booking.paymentUrl !== '')) ? (
                                                                                <div className="d-flex align-items-center">
                                                                                    <img src="/images/Razorpay_logo.svg.png" alt="Razorpay" style={{ height: '15px', verticalAlign: 'middle' }} />
                                                                                    {(booking.paymentStatus === 'pending' || booking.paymentStatus === 'failed') && (
                                                                                        <button 
                                                                                            className="btn btn-sm btn-outline-primary ms-2" 
                                                                                            onClick={() => handleSyncPayment(booking.clientTxnId)}
                                                                                            style={{ fontSize: '10px', padding: '2px 6px' }}
                                                                                            title="Sync payment status with Razorpay"
                                                                                        >
                                                                                            <span id={`sync-loading-${booking.clientTxnId}`} style={{ display: 'none' }} className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                                                                            Sync
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                            ) : (
                                                                                booking.paymentMode
                                                                            )
                                                                        }
                                                                    </td>
                                                                    <td className={`${(parseFloat(booking.udf1) === booking.amount) ? "bg-success-subtle border-dark-subtle border-start border-end" :
                                                                        (parseFloat(booking.udf1) < booking.amount ? 'bg-warning-subtle border-dark-subtle border-start border-end' :
                                                                            (parseFloat(booking.udf1) === "" ? '' : ''))
                                                                        }`}>{booking.udf1} </td> {/* partial Payment */}
                                                                    <td className={`${booking.udf2 && booking.udf2 !== '0' ? 'bg-warning-subtle text-danger fw-bold border-dark-subtle border-start border-end' : 'bg-success-subtle border-dark-subtle border-start border-end'}`}>{booking.udf2 ? booking.udf2 : "No Dues"}</td> {/* Amount due */}
                                                                    <td className='fw-bold'>{booking.amount}</td>
                                                                    <td>
                                                                        <ul className='list-unstyled mb-0'>
                                                                            {booking.seatDetails.map((seat, seatIndex) => (

                                                                                <li className="text-nowrap rounded border py-1 px-2 mb-1 d-flex align-items-center justify-content-between" style={{ 'marginTop': '-1px' }} key={seatIndex}>
                                                                                    <span className='fw-medium'>Seat: </span><span>{seat.seatNumber ? seat.seatNumber : "?"}</span> | <span className='fw-medium'>Slot: </span> <span className='text-capitalize'>{seat.slot}</span> |  <span className='fw-medium'>Type:</span> <span className={`px-1 ms-1 text-capitalize text-bg-${seat.type === 'new' ? 'warning' : 'success'}`}>{seat.type}</span>
                                                                                    {/* <span className='fw-medium'>Seat Number: </span><span>{seat.seatNumber}</span> | <span className='fw-medium'>Slot: </span> <span className='text-capitalize'>{seat.slot}</span> |  <span className='fw-medium'>Valid Till:  </span><span>{seat.seatValidTill ? formatDate(seat.seatValidTill) : seat.seatValidTill}</span> |  <span className='fw-medium'>Type:</span> <span className={`px-1 text-capitalize rounded text-bg-${seat.type === 'new' ? 'warning' : 'success'}`}>{seat.type}</span> */}
                                                                                </li>

                                                                            ))}
                                                                        </ul>
                                                                    </td>
                                                                    <td>{booking.locker === true ? 'Yes' : 'No'}</td>
                                                                    <td>{booking.securityDeposit === true ? 'Yes' : 'No'}</td>
                                                                    <td><button className='send-email btn-sm mb-0' onClick={() => handleSendReceipt(booking.clientTxnId)}><span id={`loading-${booking.clientTxnId}`} style={{ display: 'none' }} className="spinner-border spinner-border-sm" aria-hidden="true"></span>Send</button></td>
                                                                    {/* <td>{formatDate(booking.createdAt)}</td> */}
                                                                    <td>{booking.totalPrice}</td>
                                                                    <td>{booking.discountCoupon ? booking.discountCoupon : "No"}</td>
                                                                    <td>{booking.discountValue}</td>
                                                                    {/* <td>{booking.orderStatus ? 'True' : 'False'}</td> */}
                                                                    <td>{booking.pCash}</td>
                                                                    <td>{booking.pOnline}</td>
                                                                    {/* <td>{booking.pInfo}</td> */}

                                                                    <td>
                                                                        <ul className='list-unstyled mb-0'>
                                                                            {booking.validityInfo.map((info, idx) => (
                                                                                <li className={`ps-1 mb-1 ${info <= '31' ? 'bg-success text-light' : info > '31' ? 'bg-danger text-light' : ''}`} key={idx}>{info === '1' ? ('3' + info) : info} Days</li>
                                                                            ))}
                                                                        </ul>
                                                                    </td>

                                                                    <td>
                                                                        <ul className='list-unstyled mb-0'>
                                                                            {booking.statusRemark && booking.statusRemark.map((info, idx) => (
                                                                                <li className={`ps-1 mb-1 text-nowrap`} key={idx}>{info}</li>
                                                                            ))}
                                                                        </ul>
                                                                    </td>

                                                                    <td>{booking.customerEmail}</td>
                                                                    <td>{booking.customerMobile}</td>
                                                                    <td>{booking.udf3 ? booking.udf3 : "No notes"}</td> {/* Notes */}
                                                                    <td>{formatDate(booking.updatedAt)}</td>
                                                                    <td>
                                                                        <div className='d-flex align-items-center justify-content-between'>
                                                                            {(adminLoggedIn === "Superadmin") ?
                                                                                <>
                                                                                    <span><button className="btn btn-danger btn-sm mb-0 me-2" onClick={() => handleDeleteClick(booking)}>Delete</button></span>
                                                                                    <DeleteConfirmationModal
                                                                                        show={showDeleteModal}
                                                                                        handleClose={handleCloseDeleteModal}
                                                                                        handleConfirm={() => deleteBooking(bookingToDelete._id)}
                                                                                        bookingDetails={bookingToDelete}
                                                                                    />
                                                                                </>
                                                                                : ""}
                                                                            <span><Link to={`/editbookings/${booking._id}`} className="btn btn-primary btn-sm">Edit</Link></span>
                                                                        </div>
                                                                    </td>
                                                                </>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>

                                            {/* Pagination Controls */}
                                            {totalPages > 1 && (
                                                <div className='card-footer bg-light border-0 py-3'>
                                                    <div className='d-flex justify-content-between align-items-center'>
                                                        <div className='text-muted small'>
                                                            Showing page {currentPage} of {totalPages} ({totalBookings} total bookings)
                                                        </div>
                                                        <div className='d-flex gap-2'>
                                                            <button
                                                                className="btn btn-outline-primary btn-sm px-3"
                                                                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                                                disabled={currentPage === 1}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-chevron-left" viewBox="0 0 16 16">
                                                                    <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                                                                </svg>
                                                                Previous
                                                            </button>
                                                            <span className='px-3 py-2 bg-white border rounded d-flex align-items-center'>
                                                                <strong>{currentPage}</strong>
                                                            </span>
                                                            <button
                                                                className="btn btn-outline-primary btn-sm px-3"
                                                                onClick={() => setCurrentPage((prev) => (prev < totalPages ? prev + 1 : prev))}
                                                                disabled={currentPage === totalPages}
                                                            >
                                                                Next
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
                                                                    <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
};

export default BookingManager;
